// styles
import './InputsContainer.scss'

export default function InputsContainer({children}) {
    return (
        <div className='inputs-container-container'>
            {children}
        </div>
    )
}